import { render, staticRenderFns } from "./StoragePR.vue?vue&type=template&id=497e3612&scoped=true&"
import script from "./StoragePR.vue?vue&type=script&lang=js&"
export * from "./StoragePR.vue?vue&type=script&lang=js&"
import style0 from "./StoragePR.vue?vue&type=style&index=0&id=497e3612&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497e3612",
  null
  
)

export default component.exports